import { Flex } from '@components';
import { styled } from '@mui/material';

export const Container = styled(Flex)(({ theme }) => ({
  flexDirection: 'row',
  overflow: 'hidden',
  height: '100%',
}));

export const InfoCarouselContainer = styled(Flex)(({ theme }) => ({
  flexDirection: 'column',
  flex: '1 1 auto',
  width: '35%',
  backgroundColor: theme.palette.primary.dark,
  padding: theme.spacing(16),
  overflow: 'hidden',
  justifyContent: 'space-between',
  alignItems: 'space-between',
  [theme.breakpoints.down('md')]: {
    display: 'none',
  },
}));

export const StyledBackgroundImage = styled('img')(() => ({
  position: 'absolute',
  top: 0,
  height: '100%',
  opacity: 0.3,
}));

export const StyledLogo = styled('img')(({ theme }) => ({
  width: '100%',
  height: '100%',
  maxWidth: 140,
  maxHeight: 50,
  marginBottom: theme.spacing(16),
}));

export const FormContainer = styled(Flex, {
  shouldForwardProp: (prop) => prop !== 'hasFooter',
})<{
  hasFooter: boolean;
}>(({ theme, hasFooter }) => ({
  flex: '1 1 auto',
  width: '65%',
  height: '100%',
  maxHeight: '100%',
  overflowY: 'auto',
  flexDirection: 'column',
  paddingBottom: hasFooter ? 80 : 0,
  [theme.breakpoints.down('md')]: {
    paddingBottom: theme.spacing(18),
  },
}));

export const HeaderContainer = styled(Flex)(({ theme }) => ({
  padding: theme.spacing(16),
  justifyContent: 'flex-end',
  alignItems: 'center',
  [theme.breakpoints.down('md')]: {
    padding: theme.spacing(14, 8),
    justifyContent: 'space-between',
    backgroundColor: theme.palette.secondary.main,
  },
}));
